import React from 'react';
import { i18n as I18n, withTranslation } from 'utils/i18n';

// components
import Page from 'components/page';
import Registration from 'components/registration';

const RegistrationPage = () => {
  return (
    <Page
      title={I18n.t('headers.registration_page.title')}
      description={I18n.t('headers.registration_page.description')}
    >
      <div
        className="register-banner"
        style={{ backgroundImage: `url('../images/registration-banner.jpg')` }}
      />
      <main className="registration_page">
        <section>
          <div className="section-content">
            <Registration />
          </div>
        </section>
      </main>
    </Page>
  );
};

RegistrationPage.getInitialProps = async () => ({
  namespacesRequired: ['common'],
});

export default withTranslation('common')(RegistrationPage);
